import "./MarketMoversGridComponent.scss";
import template from "./MarketMoversGridComponent.html";
import {IComponentOptions} from "angular";
import {encodeSecurity} from "../../../../instruments/types/CodeAndExchange";
import {MarketMoverModel, MarketMoverModels} from "../../models/MarketMoversStateModel";
import {ComponentCallback} from "../../../../types/AngularJS";

export const MarketMoversGrid = "tfMarketMoversGrid";

export function marketMoversGrid(): IComponentOptions {
    return {
        template,
        bindings: {
            movers: "<",
            hasClickHandler: "<",
            onClick: "&"
        },
        controllerAs: "ctrl",
        controller: MarketMoversGridComponentController
    };
}

export class MarketMoversGridComponentController {
    /** @input */
    public readonly movers: MarketMoverModels;
    /** @input */
    public readonly hasClickHandler: boolean;
    /** @output */
    public readonly onClick: ComponentCallback;

    public moverId(mover: MarketMoverModel): string {
        return encodeSecurity(mover);
    }
}
